import styled from 'styled-components';
import { colors } from './colors';

export const GenericError = styled.p`
  color: ${colors.red};
  font-weight: 400;
`;
